import { Component, OnInit, EventEmitter } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';
import { ApiRequestService } from "../../../_services/api-request.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PaginationComponent } from '../pagination/pagination.component';

declare var $:any;
declare var Materialize:any;

@Component({
  selector: 'app-subscribe-result',
  templateUrl: './subscribe-result.component.html',
  styleUrls: ['./subscribe-result.component.css']
})
export class SubscribeResultComponent implements OnInit {

  search : string = '';
  subscriptionModal = new EventEmitter<string | MaterializeAction>();
  registerModal = new EventEmitter<string | MaterializeAction>();
  moreDetailsModal = new EventEmitter<string | MaterializeAction>();


  Result_data:any;
  FixedColumn;
  FilterDataResult;


  SubscriberName = '';
  SubscriberDesignation = '';
  SubscriberSpecialty = '';
  Subscriber_Clinic_hospital = '';
  SubscriberEmail = '';

  loading = 0;

  New_Username = '';
  New_Designation = '' 
  New_Specialty = '';
  New_Hospital = '';
  New_Email = '';
  New_Password = '';
  New_Confirm = '';

  Limitation_List = [10,15,20,50];
  offset: number = 1;
  limit:any = 10;
  size: number;

  constructor(private apirequest : ApiRequestService, private route:ActivatedRoute , private router: Router) { }

  ngOnInit() {
    this.search = this.route.snapshot.params['searchId'];
    console.log(this.search);   
    this.verifyEmail();
  }

  verifyEmail() {
      console.log(this.search);
      let data = {
        token: this.search,
        action: 'get_result'
      };
      console.log(data);
      
      this.apirequest.customize_flow(data).subscribe((res) => {
        console.log(res);
        if(res.status == "True"){
          this.query_result_flow(res.msg);
        } else {
          this.msg_view(res.msg)
        }
      });
  }

  query_result_flow(data){
    this.Result_data = data;
    localStorage.setItem("Result_data", JSON.stringify(this.Result_data));
    this.setTableData();
    $(document).ready(function() {
      $('.tooltipped').tooltip();
    });
    this.limitset();
  }

  setTableData(){
    this.FilterDataResult = this.Result_data.data;
    this.FixedColumn = Object.keys(this.Result_data.data[0]);
    console.log(this.FixedColumn);
    
  }

  subscription_modal_open(){
    this.subscriptionModal.emit({action: 'modal', params: ['open']});
  }

  subscription_modal_close(){
    this.subscriptionModal.emit({action: 'modal', params: ['close']});
  }

  register_modal_open(){
    this.registerModal.emit({action: 'modal', params: ['open']});
  }

  register_modal_close(){
    this.registerModal.emit({action: 'modal', params: ['close']});
  }

  more_details_modal_open(){
    this.moreDetailsModal.emit({action: 'modal', params: ['open']});
  }

  more_details_modal_close(){
    this.moreDetailsModal.emit({action: 'modal', params: ['close']});
  }

  subClose_regOpen(){
    this.subscription_modal_close();
    this.register_modal_open();
  }

  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  Subscribe(){
    this.loading = 1;   
    let data =  {
       action:"subscribe_user",
       name: this.SubscriberName,
       designation: this.SubscriberDesignation,
       hospital_name:this.Subscriber_Clinic_hospital,
       speciality: this.SubscriberSpecialty,
       sub_email: this.SubscriberEmail,
       result_code: this.Result_data.result_code 
      };
    console.log(data);
      
    this.apirequest.customize_flow(data).subscribe(res => {
      console.log(res);
      if(res.status == "True"){
        this.loading = 0;
        this.msg_view(res.msg);
        this.subscription_modal_close();
      } else {
        this.msg_view(res.msg);
        this.loading = 0;
      }       
    });
    
  }

  Register(){
    
  }

  GoAnalysis(){
    this.router.navigate(['/subscribe/result/analysis']);
  }

  limitset(){
    this.size = this.Result_data.case_no;
    console.log(this.limit);
    PaginationComponent.pageNumber = 1;
    this.offset = 1;
    this.getPaginatedResult();
  }
  
  onPageChange(offset: number) {
    this.offset = offset;
    console.log(offset);
    console.log(PaginationComponent.pageNumber);
    this.getPaginatedResult();
  }

  getPaginatedResult(){
    let data = {
      action: 'apply_pagination',
      result_code: this.Result_data.result_code,
      email: this.Result_data.email,
      range:parseInt(this.limit),
      page_no: PaginationComponent.pageNumber

    };
    console.log(data);
    
    this.apirequest.customize_flow(data).subscribe((res) => {
      console.log(res);
      if(res.status == "True"){
        let tabledata = res.msg;
        this.FilterDataResult = tabledata.data;
      } else {
        this.msg_view(res.msg)
      }
    });
  }


  // {"action":"apply_pagination", "email":"kawish@codexnow.com", "result_code": 11066708, "range":10, "page_no": 1}
  

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/subscribe-result/subscribe-result.component.ts